import { TLanguage } from 'ts/types';
import { TResponse } from 'ts/types/TResponse';
import { AxiosCustom } from './axios-client';

export async function getListLanguagesAPI(): Promise<TResponse<TLanguage[]>> {
  const res = await AxiosCustom.get(`languages`);
  return res.data;
}
